import { map, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SettingsService } from '../services/settings.service';
import { ServerResponse } from '../response';
import { UserGpsData } from '../models/interfaces/tracker_point.interface';

@Injectable({
  providedIn: 'root',
})
export class MapDomainService {
  constructor(
    private settingService: SettingsService,
    private http: HttpClient
  ) {}

  // Устанавливает позицию нового слоя карты
  newMapLayerPosition(customMapFileUid: string, bounds: number[][], clUid: string, rUid: string): Observable<void> {
    return this.http.post(
      `${this.settingService.settings.urlGTM}/api/race/class/custom_map`,
      {
        customMapFileUid,
        clUid,
        rUid,
        bounds,
      }
    ).pipe(
      map(() => undefined)
    );
  }

  // Создаёт отметки маршала по GPS
  createMarshalMarksByGps(rUid: string, clUid: string, trackers: { cUid: string; trackers: string[] }[]): Observable<void> {
    return this.http.post(
      `${this.settingService.settings.urlGTM}/api/map/create_marshal_marks_by_gps`,
      {
        rUid,
        clUid,
        trackers,
      }
    ).pipe(
      map(() => undefined)
    );
  }

  // Возвращает GPS трек
  getTrack(trackRequest: any): Observable<{ uid: string; points: UserGpsData[] }> {
    return this.http
      .post<ServerResponse<{ uid: string; points: UserGpsData[] }>>(
        `${this.settingService.settings.urlGTM}/api/map/track`,
        trackRequest
      )
      .pipe(
        map((res: any) => res.data)
      );
  }
}
